import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ENDPOINTS } from "../constants/actionTypes";

export const crudApi = createApi({
  reducerPath: "crudApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/",
    prepareHeaders: (headers) => {
      const token =
        localStorage.getItem("authToken") ||
        sessionStorage.getItem("authToken");
      if (token && token !== "null" && token !== "undefined") {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Company", "CompanyUser", "BranchSetting"], // Add more as needed
  endpoints: (builder) => ({
    // Company CRUD
    getCompanies: builder.query({
      query: () => API_ENDPOINTS.COMPANY.SELECT_ALL,
      providesTags: ["Company"],
    }),
    getCompanyById: builder.query({
      query: (id) => ({
        url: API_ENDPOINTS.COMPANY.SELECT_BY_ID + "/" + id,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Company", id }],
    }),
    addCompany: builder.mutation({
      query: (data) => ({
        url: API_ENDPOINTS.COMPANY.INSERT,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
    updateCompany: builder.mutation({
      query: (data) => ({
        url: API_ENDPOINTS.COMPANY.UPDATE,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Company"],
    }),
    deleteCompany: builder.mutation({
      query: (id) => ({
        url: `${API_ENDPOINTS.COMPANY.DELETE}?id=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Company"],
    }),

    // CompanyUser CRUD - extend similarly
    getCompanyUsers: builder.query({
      query: () => API_ENDPOINTS.COMPANY_USER.SELECT_ALL,
      providesTags: ["CompanyUser"],
    }),

    // BranchSetting etc...
  }),
});

export const {
  useGetCompaniesQuery,
  useGetCompanyByIdQuery,
  useAddCompanyMutation,
  useUpdateCompanyMutation,
  useDeleteCompanyMutation,
  useGetCompanyUsersQuery,
} = crudApi;
